import React from 'react';
import classnames from 'classnames';
import styles from './signer-avatar.scss';
import { Signer } from 'hellospa/components/editor/types';

type AvatarProps = {
  signerId: Signer['id'],
  name: Signer['name'],
  className?: string,
}

// This cleans out punctuation so things like "Me (now)" become "MN" instead of
// "M("
const punctuation = /[^\w\s]/g;

export default function SignerAvatar({ signerId, name, className }: AvatarProps) {
  const chunks = name
    .replace(punctuation, '')
    .toUpperCase()
    .split(/\s/);

  let initials = chunks[0][0];

  if (chunks.length > 1) {
    initials += chunks[chunks.length - 1][0];
  }

  return (
    <div className={classnames(
      className,
      styles.avatar,
      styles[`assigneeColor-${signerId}`],
    )}
    >
      <span className={styles.initials}>
        {initials}
      </span>
    </div>
  );
}
